<template>
  <div class="mypage">
    <TitleFrame text="マイページ">
      <template slot="contents">
        <div class="content-area">
          <MyData />
          <div class="no-account-area" v-if="!isLoggedInWithFirebaseAuth">
            <p>アカウントを作成していない場合はユーザー登録してください</p>
            <ButtonTextLink
              class="button"
              @click-text="onClickSignup"
              text="ユーザー登録"
            />
          </div>
          <PresentButton @click-button="onClickOpenPresent" />
          <div class="button-wrapper">
            <ButtonTextLink
              class="button"
              @click-text="onClickAnswers"
              text="事後アンケート"
            />
          </div>
          <div>
            <MissionList @click-mission="onClickMission" />
            <CheckInList @click-mission="onClickMission" />
          </div>
          <p class="list-title">その他</p>
          <ul>
            <li @click="onClickGaiyo">
              <p>実験概要</p>
              <img class="chev" src="@/assets/chevron.svg" />
            </li>
            <li @click="onClickHowToUse">
              <p>利用方法</p>
              <img class="chev" src="@/assets/chevron.svg" />
            </li>
            <li @click="onClickKiyaku">
              <p>利用規約</p>
              <img class="chev" src="@/assets/chevron.svg" />
            </li>
            <li @click="onClickPrivacy">
              <p>プライバシーポリシー</p>
              <img class="chev" src="@/assets/chevron.svg" />
            </li>
            <li @click="onClickToiawase">
              <p>お問い合わせ</p>
              <img class="chev" src="@/assets/chevron.svg" />
            </li>
            <KenriDialog />
            <li v-if="isLoggedInWithFirebaseAuth" @click="onClickLogout">
              <p>ログアウト</p>
              <img class="chev" src="@/assets/chevron.svg" />
            </li>
            <DeleteUserDialog v-if="isLoggedInWithFirebaseAuth" />
          </ul>
        </div>
      </template>
    </TitleFrame>
    <Caution />
    <DropSpotSelectModal
      v-if="selectedSpot"
      :current="current"
      @click-close="onClickCloseModal"
    />
    <PresentModal v-if="isOpenPresent" @click-button="onClickClosePresent" />
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import TitleAndText from "@/components/Atoms/TitleAndText";
import TitleFrame from "@/components/Templates/TitleFrame";
import TextLinkInline from "@/components/Atoms/TextLinkInline";
import ButtonTextLink from "@/components/Atoms/ButtonTextLink";
import MyData from "@/components/MyPage/MyData";
import CheckInList from "@/components/MyPage/CheckInList";
import MissionList from "@/components/MyPage/MissionList";
import PresentButton from "@/components/MyPage/PresentButton";
import PresentModal from "@/components/MyPage/PresentModal";
import KenriDialog from "@/components/MyPage/KenriDialog";
import DeleteUserDialog from "@/components/MyPage/DeleteUserDialog";
import Caution from "@/components/MyPage/Caution";
import Firebase from "./../../firebase";
import axios from "axios";
import DropSpotSelectModal from "@/components/Modals/DropSpotSelectModal";

export default {
  name: "my-page",
  components: {
    TitleAndText,
    TitleFrame,
    TextLinkInline,
    DropSpotSelectModal,
    MyData,
    CheckInList,
    MissionList,
    ButtonTextLink,
    Caution,
    PresentButton,
    PresentModal,
    KenriDialog,
    DeleteUserDialog,
  },
  computed: {
    ...mapState([
      "checkinList",
      "registrationId",
      "missions",
      "registrationData",
      "selectedSpotData",
      "isLoggedInWithFirebaseAuth",
    ]),
    selectedSpot() {
      if (this.current === "RouteSearch") {
        return this.selectedSpotData.dropspot;
      } else if (this.current === "MyPage") {
        return this.selectedSpotData.mypage;
      } else if (this.current === "JyutaiSearch") {
        return this.selectedSpotData.jyutai;
      }
    },
  },
  props: {
    current: { type: String, default: false, required: true },
  },
  data() {
    return {
      isOpenPresent: false,
    };
  },
  methods: {
    ...mapMutations([
      "loadingStartMini",
      "loadingEndMini",
      "openDetailModalInHelpModal",
      "setSelectedSpotData",
      "setModal",
    ]),
    onClickSignup() {
      this.setModal("signup");
    },
    onClickCloseModal() {
      this.setSelectedSpotData(undefined);
    },
    async onClickMission(spotId) {
      this.loadingStartMini();
      let param = {
        api_key: "i73rauGTyfewa",
      };
      await axios
        .get(
          `https://mission-kqxgrnovcq-uc.a.run.app/api/spots/${spotId}`,
          { params: param },
        )
        .then((response) => {
          this.setSelectedSpotData(response.data[0]);
        });
      await Firebase.getSpot(this.current);
    },
    onClickOpenPresent() {
      this.isOpenPresent = true;
    },
    onClickClosePresent() {
      this.isOpenPresent = false;
    },
    onClickAnswers() {
      window.open(
        `https://docs.google.com/forms/d/e/1FAIpQLSe5VZ0GzUH1Ya6F19IbmSq0xJfU8o_57n3jkMuh3sG70eVYfw/viewform?usp=sf_link&entry.1414804583=${this.registrationId}`,
        "_blank",
      );
    },
    onClickGaiyo() {
      window.open(
        "https://www.suisuitabi.org/%E3%82%B9%E3%82%A4%E3%82%B9%E3%82%A4%E6%97%85%E5%B1%B1%E6%A2%A8%E7%89%88",
        "_blank",
      );
    },
    onClickHowToUse() {
      window.open(
        "https://www.suisuitabi.org/%E3%82%B9%E3%82%A4%E3%82%B9%E3%82%A4%E6%97%85%E5%B1%B1%E6%A2%A8%E7%89%88/%E5%88%A9%E7%94%A8%E6%96%B9%E6%B3%95",
      );
    },
    onClickKiyaku() {
      window.open(
        "https://www.suisuitabi.org/%E3%82%B9%E3%82%A4%E3%82%B9%E3%82%A4%E6%97%85%E5%B1%B1%E6%A2%A8%E7%89%88/%E5%88%A9%E7%94%A8%E8%A6%8F%E7%B4%84",
        "_blank",
      );
    },
    onClickPrivacy() {
      window.open(
        "https://www.suisuitabi.org/%E3%82%B9%E3%82%A4%E3%82%B9%E3%82%A4%E6%97%85%E5%B1%B1%E6%A2%A8%E7%89%88/%E3%83%97%E3%83%A9%E3%82%A4%E3%83%90%E3%82%B7%E3%83%BC%E3%83%9D%E3%83%AA%E3%82%B7%E3%83%BC",
        "_blank",
      );
    },
    onClickToiawase() {
      window.open(
        "https://docs.google.com/forms/d/e/1FAIpQLScoJ2Pi-BPLtYvzRuMCVsSaJ1ANLANJaUIis2P_koH9c_zMxg/viewform",
        "_blank",
      );
    },
    onClickLogout() {
      Firebase.logout();
      location.reload();
    },
    async onClickDeleteAccount() {
      await Firebase.deleteAccount();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";
.mypage {
  height: 100%;
  z-index: 1;
  position: relative;
}
.no-account-area {
  margin: 1rem 1.25rem;
  p {
    font-size: 0.7rem;
    text-align: center;
  }
  .button {
    margin: 1rem auto;
  }
}
.button-wrapper {
  margin: 0 auto;
  width: calc(100% - 1.25rem * 2);
}

.list-title {
  text-align: left;
  margin: 2rem 1.25rem 0;
  font-size: 0.8rem;
}

ul {
  list-style: none;
  padding-left: 0;
  border-bottom: 1px #e7e7e7 solid;
  margin: 0.5rem 1.25rem 5rem;
  li {
    margin: 0;
    display: flex;
    padding: 1rem 0.5rem;
    font-size: 0.8rem;
    border-top: 1px #e7e7e7 solid;
    align-items: center;

    .chev {
      transform: rotate(-90deg);
      height: 0.5rem;
    }
    p {
      margin: 0;
      width: calc(100% - 1.5rem);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/MyPage.vue